<template>
  <BaseButton
    :size="size"
    :data-testid="dataTestId"
    class="tw:font-bold tw:border tw:border-gray-600 tw:text-gray-800 tw:bg-white"
    v-bind="$attrs"
  >
    <slot />
  </BaseButton>
</template>

<script setup>
import BaseButton from './BaseButton.vue'

defineProps({
  size: {
    type: String,
    default: 'big',
  },
  dataTestId: {
    type: String,
    default: '',
  },
})
</script>

<style scoped>
@media (hover: hover) and (pointer: fine) {
  button:hover {
    background-color: var(--tw-color-gray-800);
    color: var(--tw-color-white);
    border-color: var(--tw-color-gray-900);
  }
}
button:disabled {
  color: var(--tw-color-gray-300);
  border-color: var(--tw-color-gray-300);
}
</style>
